module.exports = __webpack_public_path__ + "static/media/volksbank-mobileWithLogo2.081c2894.png";